import type { DetectorCatalogResponse } from '@prerender/diagnostics-api';

import api from '../../api/apiSlice';

export const detectorCatalogApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDetectorCatalog: builder.query<DetectorCatalogResponse, void>({
      query: () => '/diagnostics/detectors',
    }),
  }),
});

export const { useGetDetectorCatalogQuery, useLazyGetDetectorCatalogQuery } = detectorCatalogApi;
